import { render, staticRenderFns } from "./JdsReactionBadge.vue?vue&type=template&id=c39dc364&scoped=true&"
import script from "./JdsReactionBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsReactionBadge.vue?vue&type=script&lang=ts&"
import style0 from "./JdsReactionBadge.vue?vue&type=style&index=0&id=c39dc364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39dc364",
  null
  
)

export default component.exports